module.exports = __webpack_public_path__ + "img/fig24.5299c987.jpg";